import React from 'react';
import { Box, Card, CardContent, Typography, Divider, Checkbox, Radio } from '@mui/material';
import { FormQuestionWithOptions } from '../../../services/apiSLTP/qhse/forms/formQuestions';
import { FormAnswer } from '../../../services/apiSLTP/qhse/forms/formAnswers';
import { questionTypeEnum } from '../../../utils/enums';
import CustomTextInput from '../../CustomTextInput';

interface QuestionResponseItemProps {
    question: FormQuestionWithOptions;
    answer?: FormAnswer;
    number: number;
}

const QuestionResponseItem: React.FC<QuestionResponseItemProps> = ({ question, answer, number }) => {
    const value = answer?.value ?? null;

    const renderValue = () => {
        switch (question.type) {
            case questionTypeEnum.SINGLE_CHOICE:
            case questionTypeEnum.MULTIPLE_CHOICE: {
                const selectedValues = Array.isArray(value) ? value : value ? [value] : [];

                return (
                    <Box display="flex" flexDirection="column" gap={0.5}>
                        {question.options?.map((opt) => {
                            const isSelected = selectedValues.includes(opt.value);
                            return (
                                <Box key={opt._id} display="flex" alignItems="center" gap={1}>
                                    {question.type === questionTypeEnum.SINGLE_CHOICE ? (
                                        <Radio checked={isSelected} disabled={!isSelected} />
                                    ) : (
                                        <Checkbox checked={isSelected} disabled={!isSelected} />
                                    )}
                                    <Typography color={isSelected ? 'text.primary' : 'text.disabled'} sx={{ fontWeight: isSelected ? 500 : 400 }}>
                                        {opt.value}
                                    </Typography>
                                </Box>
                            );
                        })}
                    </Box>
                );
            }

            case questionTypeEnum.TEXT_SHORT:
            case questionTypeEnum.TEXT_LONG:
                return <CustomTextInput value={value || ''} multiline={question.type === questionTypeEnum.TEXT_LONG} />;

            default:
                return (
                    <Typography variant="body2" color="text.secondary">
                        {value ? String(value) : '(aucune réponse)'}
                    </Typography>
                );
        }
    };

    return (
        <Box>
            <CardContent sx={{ p: 1 }}>
                <Typography variant="h6" sx={{ fontWeight: 600 }}>
                    {`${number}. ${question.title}`}
                    {question.required && (
                        <Typography variant="h6" component="span" color="error">
                            {' *'}
                        </Typography>
                    )}
                </Typography>

                <Box sx={{ pointerEvents: 'none' }}>{renderValue()}</Box>

                {answer?.observations && (
                    <Typography
                        variant="caption"
                        color="text.secondary"
                        sx={{ mt: 1, display: 'block', fontStyle: 'italic', whiteSpace: 'pre-line' }}
                    >
                        Observation : {answer.observations}
                    </Typography>
                )}
            </CardContent>
        </Box>
    );
};

export default QuestionResponseItem;
